const trimmedCountriesName = {
  US: "United States",
  CA: "Canada",
};
export default trimmedCountriesName;
